import React from 'react';
import { Box, Typography } from 'glints-aries';

export const Title: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <Box mb={12}>
      <Typography.Title tag="h3">{children}</Typography.Title>
    </Box>
  );
};
